module.exports = ".dashboard-logo {\n  height: 30px; }\n\n.logo-zoomed {\n  -webkit-transform: scale(2);\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  height: 20px; }\n\n.avatar img {\n  height: 30px;\n  scale: 2; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar/navbar.component.scss
// module id = ./src/app/shared/navbar/navbar.component.scss
// module chunks = main